
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { ConfiguratorProvider } from './context/ConfiguratorContext.tsx';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ConfiguratorProvider>
      <App />
    </ConfiguratorProvider>
  </StrictMode>,
);
